// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1GNsj","icon":"style_icon__ZGxmC","title":"style_title__1k2Zo","menuIcon":"style_menuIcon__1Ykmn"};